import { type APIError } from "@/lib/types";
import { type AxiosError } from "axios";
import toast from "react-hot-toast";

export const toastAPIErrorMessage = (
  error: AxiosError<APIError>,
  fallbackMessage: string,
) => {
  const userMessage = (error.response?.data as Partial<APIError> | undefined)
    ?.meta?.userMsg;
  if (userMessage) {
    toast.error(userMessage);
  } else {
    toast.error(fallbackMessage);
  }
};

export const concatArraysCustomizer = (
  objValue: unknown,
  srcValue: unknown,
): unknown => {
  if (Array.isArray(objValue) && Array.isArray(srcValue)) {
    return [...(objValue as unknown[]), ...(srcValue as unknown[])] as unknown;
  }
  return undefined as unknown;
};
